<!-- 审核面板 -->
<template>
    <div class="form-group" ref="scrollableDiv">
        <!-- 菜单栏 -->
        <div>
            <!-- 任务选择栏 -->
            <div style="display: flex; justify-content: space-between">
                <!-- 选择任务 -->
                <div style="text-align: left">
                    <h2 style="color: #fff">选择任务</h2>
                    <el-select filterable v-model="menuselect.taskId" clearable placeholder="选择任务名称"
                        @change="getformdataMenuData('initall2')" style="width: 150px; margin-right: 15px">
                        <el-option v-for="item in taskrunList" :key="item.id" :label="item.templateName"
                            :value="item.id" />
                    </el-select>
                    <el-input v-model="menuselect.patch" clearable placeholder="输入批次" @change="searchTask('initall')"
                        style="width: 150px" />
                    <h2 style="color: #fff">筛选菜单栏</h2>
                </div>
                <!-- 任务量提示 -->
                <div style="display: flex" v-if="prop.show4num">
                    <div style="display: flex; flex-direction: column; margin-right: 20px">
                        <span style="color: #fff; font-size: 30px">{{ nowchecknumDict.numberOfAudited }} |</span>
                        <span style="color: #fff; text-align: center">已审核</span>
                    </div>
                    <div style="display: flex; flex-direction: column; margin-right: 20px">
                        <span style="color: #fff; font-size: 30px">{{ nowchecknumDict.numberOfUnAudited }} |</span>
                        <span style="color: #fff; text-align: center">未审核</span>
                    </div>
                    <div style="display: flex; flex-direction: column; margin-right: 20px">
                        <span style="color: #fff; font-size: 30px">{{ nowchecknumDict.numberOfSuccessTotal }} |</span>
                        <span style="color: #fff; text-align: center">已出价</span>
                    </div>
                    <div style="display: flex; flex-direction: column">
                        <span style="color: #fff; font-size: 30px">{{ nowchecknumDict.numberOfTotal }}</span>
                        <span style="color: #fff; text-align: center">任务总数</span>
                    </div>
                </div>
            </div>
            <!-- 筛选菜单栏 -->
            <div style="text-align: left">
                <el-form :inline="true" :data="menuselect">
                    <el-row :gutter="0">
                        <!-- 选择平台 -->
                        <el-col :span="7">
                            <el-form-item style="width: 220px">
                                <el-select @change="getformdataMenuData('s', 'sources')"
                                    v-model="menuselect.sourcesList" clearable placeholder="选择平台" filterable
                                    collapse-tags collapse-tags-tooltip>
                                    <el-option v-for="(item, index) in formdataMenu.sourcesList" :key="index"
                                        :label="item" :value="item" />
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <!-- 选择品牌 -->
                        <el-col :span="7">
                            <el-form-item style="width: 220px">
                                <el-select @change="getformdataMenuData('b')" filterable v-model="menuselect.brandList"
                                    clearable placeholder="选择品牌" collapse-tags collapse-tags-tooltip>
                                    <el-option v-for="(item, index) in formdataMenu.brandList" :key="index"
                                        :label="item" :value="item" />
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <!-- 选择型号 -->
                        <el-col :span="7">
                            <el-form-item style="width: 220px">
                                <el-select @change="getformdataMenuData('m')" filterable v-model="menuselect.modelList"
                                    clearable placeholder="选择型号" collapse-tags collapse-tags-tooltip>
                                    <el-option v-for="(item, index) in formdataMenu.modelList" :key="index"
                                        :label="item" :value="item" />
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <!-- 选择等级 -->
                        <el-col :span="7">
                            <el-form-item style="width: 220px">
                                <el-select @change="getformdataMenuData('g')" filterable multiple collapse-tags
                                    collapse-tags-tooltip v-model="menuselect.gradeList" clearable placeholder="选择等级">
                                    <el-option v-for="(item, index) in formdataMenu.gradeList" :key="index"
                                        :label="item.levelName" :value="item.levelName" />
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <!-- 审核状态 -->
                        <el-col :span="7">
                            <el-form-item style="width: 220px">
                                <el-select v-model="menuselect.checkStatus" clearable placeholder="审核状态">
                                    <el-option v-for="(item, index) in checkStatusmenu" :key="index" :label="item.label"
                                        :value="item.value" />
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <!-- 屏幕瑕疵 -->
                        <el-col :span="7">
                            <el-form-item style="width: 220px">
                                <el-select filterable multiple collapse-tags collapse-tags-tooltip
                                    v-model="menuselect.screenList" clearable placeholder="采货侠屏瑕疵">
                                    <el-option v-for="(item, index) in formdataMenu.screenList" :key="index"
                                        :label="item" :value="item" />
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <!-- 壳瑕疵 -->
                        <el-col :span="7">
                            <el-form-item style="width: 220px">
                                <el-select filterable multiple collapse-tags collapse-tags-tooltip
                                    v-model="menuselect.shuckList" clearable placeholder="采货侠壳瑕疵">
                                    <el-option v-for="(item, index) in formdataMenu.shuckList" :key="index"
                                        :label="item" :value="item" />
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <!-- 操作栏 -->
                    <el-row :gutter="6" style="justify-content: flex-end">
                        <!-- 按钮 -->
                        <el-col :span="7" :offset="0">
                            <el-form-item style="width: 220px">
                                <div style="display: flex; margin-left: 15px">
                                    <button class="btn" @click="searchTask('menu')">筛选</button>
                                    <button class="btn" @click="resetSelection()">重置</button>
                                </div>
                            </el-form-item>
                        </el-col>
                        <!-- 排序筛选 -->
                        <el-col :span="7" :offset="0">
                            <el-form-item style="width: 220px">
                                <el-checkbox v-show="true" v-model="orderbyfromhightolowflag" label="价格降序" size="large"
                                    border @change="searchTask('orderby')"
                                    style="height: 32px; margin-right: 10px; color: #fff" />
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
        </div>
        <!-- 数据列表展示 -->
        <el-table ref="eltableRef" :data="taskphoneList" :highlight-current-row="true"
            :header-row-style="{ color: 'white' }" border @row-click="handleRowClick" style="border-radius: 12px"
            @header-click="handleHeaderClick" :row-class-name="tableRowClassName" :cell-class-name="tableCellClassName"
            @cell-click="handleCellClick" :row-style="lastcheckstyle" :header-cell-style="headFirst">
            <!-- 行号 -->
            <el-table-column v-if="true" min-width="60" label="编号">
                <template #default="scope">
                    {{ scope.$index + 1 }}
                </template>
            </el-table-column>

            <!-- 平台 -->
            <el-table-column label="平台" min-width="80" header-align="center" align="center">
                <template #default="scope">
                    <img :src="_patformimaglogo(scope.row.sources)" v-if="_patformimaglogo(scope.row.sources)"
                        style="height: 40px" />
                    <span v-else>{{ scope.row.sources }}</span>
                    <br />
                    <span>{{ scope.row.authorization }}</span>
                </template>
            </el-table-column>

            <!-- 手机基本信息 -->
            <el-table-column label="手机基本信息" min-width="200" header-align="center" align="center">
                <template #default="scope">
                    <div>
                        <div>{{ scope.row.model }}</div>
                        <div>{{ scope.row.ram }}</div>
                        <div>{{ scope.row.storage }}</div>
                        <div>{{ scope.row.color }}</div>
                        <div>{{ scope.row.purchaseChannel }}</div>
                        <div>{{ scope.row.grade }}</div>
                        <div>电池效率{{ scope.row.batteryMin }}~{{ scope.row.batteryMax }}</div>
                    </div>
                    <span v-if="scope.row.sources == '小当竞拍'">
                        <span v-for="item in _parseQualityDesc(scope.row.allJson)" :key="item">{{ item }}</span>
                    </span>
                </template>
            </el-table-column>

            <!-- 关键词 -->
            <el-table-column label="关键词" min-width="110" header-align="center" align="center">
                <template #default="scope">
                    <span v-for="keys in scope.row.descDescribe" :key="keys" style="margin-right: 4px">{{ keys }}</span>
                </template>
            </el-table-column>

            <!-- 验机报告 -->
            <el-table-column label="验机报告" min-width="300">
                <template #default="scope">
                    <div style="max-height: 300px; overflow-y: auto">
                        <span style="margin-bottom: 15px; font-weight: 700"
                            v-for="item in _parseQualityDesc(scope.row.qualityDesc)" :key="item">{{ item }}
                            <br />
                        </span>
                        <span style="margin-bottom: 15px" v-for="item in _parseQualityDesc(scope.row.allJson)"
                            :key="item"> {{ item }} <br /> </span>
                    </div>
                </template>
            </el-table-column>

            <!-- 验机图片 -->
            <el-table-column label="验机图片" min-width="200" class-name="damagepiccolcss">
                <template #default="scope">
                    <el-image v-if="scope.row.quotedQuantity === 1" :preview-teleported="true" :infinite="true"
                        :hide-on-click-modal="true"
                        :src="loopfirstimage(scope.row.rawAllImgUrl, scope.row.rawDefectUrl)" :zoom-rate="1.2"
                        :max-scale="7" :min-scale="0.2"
                        :preview-src-list="showallimages(scope.row.rawAllImgUrl, scope.row.rawDefectUrl)"
                        :initial-index="0" fit="cover">
                        <template #error>
                            <div class="image-slot" style="text-align: center; background: #f2f6fc">
                                <span>平台无图</span>
                            </div>
                        </template>
                    </el-image>
                    <el-image v-else :preview-teleported="true" :infinite="true" :hide-on-click-modal="true"
                        :src="onemorephonepicsCircle(scope.row.rawAllImgUrl, scope.row.rawDefectUrl)[0]"
                        :zoom-rate="1.2" :max-scale="7" :min-scale="0.2"
                        :preview-src-list="onemorephonepicsCircle(scope.row.rawAllImgUrl, scope.row.rawDefectUrl)"
                        :initial-index="0" fit="cover">
                        <template #error>
                            <div class="image-slot" style="text-align: center; background: #f2f6fc">
                                <span>平台无图</span>
                            </div>
                        </template>
                    </el-image>
                    <!-- <el-image
                        :preview-teleported="true"
                        :infinite="true"
                        :hide-on-click-modal="true"
                        :src="loopfirstimage(scope.row.rawAllImgUrl, scope.row.rawDefectUrl)"
                        :zoom-rate="1.2"
                        :max-scale="7"
                        :min-scale="0.2"
                        :preview-src-list="showallimages(scope.row.rawAllImgUrl, scope.row.rawDefectUrl)"
                        :initial-index="0"
                        fit="cover" /> -->
                    <!-- <div v-else>平台无图</div> -->
                </template>
            </el-table-column>

            <!-- 起拍价 -->
            <el-table-column label="起拍价" header-align="center" align="center" min-width="70">
                <template #default="scope">
                    {{ scope.row.upsetPrice }}
                </template>
            </el-table-column>

            <!-- 预估成色 -->
            <el-table-column label="预估成色" header-align="center" align="center" min-width="90">
                <template #default="scope">
                    {{ scope.row.conditionPre }}
                    <span v-if="scope.row.conditionPre == null">-</span>
                    <!-- <span v-else>新</span> -->
                </template>
            </el-table-column>

            <!-- 转转成色 -->
            <el-table-column label="转转价" min-width="80">
                <template #default="scope">
                    <el-button :style="autobuttonheight(scope.$index)" style="width: 100%;height: 120px;" plain
                        @click="getallzzprice(scope.row, 0)" type="primary">
                        {{ scope.row.zzLowestSalePrice }}
                    </el-button>
                </template>
            </el-table-column>

            <!-- 拍机堂成色 -->
            <!-- <el-table-column label="拍机堂价" width="100">
                                <template #default="scope">
                                    {{ scope.row.pjtPrice }}
                                </template>
                            </el-table-column> -->

            <!-- 出价预估 -->
            <!-- <el-table-column label="预估出价" min-width="180" header-align="center" align="center" :filters="isPriceHighorLow" :filter-method="filterprice"> -->
            <el-table-column label="预估出价" min-width="180" header-align="center" align="center">
                <template #default="scope">
                    <el-input-number v-if="scope.row.checkStatus == -1" @change="editPrice"
                        :ref="'tab' + scope.row.index" @focus="handleFocus($event, scope.row.index)" class="price"
                        v-model="scope.row.amount" style="width: 150px" :placeholder="amount" :controls="false" />
                    <el-input-number v-else @change="editPrice" :ref="'tab' + scope.row.index"
                        @focus="handleFocus($event, scope.row.index)" class="passprice" :style="styleObject"
                        v-model="scope.row.amount" style="width: 150px" :placeholder="amount" :controls="false" />
                </template>
            </el-table-column>

            <el-table-column label="出价数量" min-width="80" header-align="center" align="center">
                <template #default="scope">
                    <span v-if="scope.row.quotedQuantity === 1">{{ scope.row.quotedQuantity }}</span>
                    <el-select v-else v-model="scope.row.orderQuotedQuantity" placeholder="请选择">
                        <el-option v-for="item in getOptions(scope.row)" :key="item" :label="item" :value="item" />
                    </el-select>
                </template>
            </el-table-column>

            <!-- 确认 -->
            <el-table-column label="操作" header-align="center" align="center" min-width="60" class-name="operatorcol">
                <template v-slot="scope">
                    <el-button plain type="success" :style="autobuttonheight(scope.$index)"
                        @click="nobuy(scope.$index, scope.row.id, scope.row.sources, scope.row.autoGeneratePrice, 1, scope.row, false)">
                        通过
                    </el-button>
                </template>
            </el-table-column>
            <!-- 跳过 -->
            <el-table-column prop="hi" header-align="center" align="center" min-width="60" class-name="operatorcol">
                <template v-slot="scope">
                    <el-button :style="autobuttonheight(scope.$index)" plain type="warning"
                        @click="nobuy(scope.$index, scope.row.id, scope.row.sources, scope.row.autoGeneratePrice, 2, scope.row, false)">
                        跳过
                    </el-button>
                </template>
            </el-table-column>

            <!-- 出价结果 -->
            <el-table-column label="审核结果" min-width="100">
                <template #default="scope">
                    <div>
                        <el-button style="width: 80px" v-if="scope.row.checkStatus == -1" type="info">待审核</el-button>
                        <el-button style="width: 80px" v-if="scope.row.checkStatus == 1" type="success">成功</el-button>
                        <el-button style="width: 80px" v-if="scope.row.checkStatus == 2" type="danger"
                            @click="getPlatFormRes(scope.row, scope.$index, scope.row.id, scope.row.sources, scope.row.autoGeneratePrice, 1)">失败</el-button>
                        <el-button style="width: 80px"
                            v-if="scope.row.checkStatus == 0 || scope.row.checkStatus == null"
                            type="primary">已审核</el-button>
                        <el-button style="width: 80px" v-if="scope.row.checkStatus == 3" type="warning">跳过</el-button>
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <!-- 页码栏 -->
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="menuselect.pageNo" :page-sizes="[10, 30, 50, 100]" :page-size="menuselect.pageSize"
            layout="total, sizes, prev, pager, next, jumper" :total="total">
        </el-pagination>
    </div>
    <!-- 弹窗部分 -->
    <div>
        <el-dialog title="转转价格" style="width: 1000px" draggable v-model="allzzpriceDialogShow">
            <!-- 操作按钮 -->
            <el-row :gutter="20">
                <div style="display: flex; justify-content: flex-end; width: 100%; margin-bottom: 12px">
                    <div>
                        <el-button :disabled="selectedItem.isButtonDisabled"
                            @click="getallzzpriceAgain(tempgoods, 1)">重新获取</el-button>
                        <el-button @click="getallzzpriceRefresh(tempgoods, 0)">刷新</el-button>
                    </div>
                </div>
            </el-row>
            <el-table stripe :data="wwe" border style="width: 100%; height: 100%; overflow-y: auto"
                :cell-style="getRowStyle" :row-style="tableRowStyle">
                <el-table-column prop="updateTime" label="估价时间" width="180" />
                <el-table-column prop="quality" label="成色" width="70" />
                <el-table-column prop="zzLowestSalePrice" label="最低销售" width="100" />
                <el-table-column :label="'结算价'" prop="zzPriceOfSettlement" width="100" />
                <el-table-column prop="title" label="对比机器" />
            </el-table>
            <!-- <el-row :gutter="20" v-for="i in rangeZZRows()" :key="i">
                <el-col :span="12" v-for="(item, index) in getZZRowData(i - 1)" :key="index">
                    <el-row :span="12">
                        <el-button style="width: 100%">
                            {{ item.condition }}新
                        </el-button>
                    </el-row>
                    <el-row class="level-row">
                        <el-col :span="6" v-for="pp in item.systemEvaluatePriceVOList" style="background-color: aqua;">
                            <el-row class="level-item"> {{ pp.quality }}级 </el-row>
                            <el-row class="level-item">
                                <div style="width: 100%; display: flex; justify-content: space-between;">
                                    <span>
                                        转转:
                                    </span>
                                    <span>
                                        {{ pp.zzLowestSalePrice }}
                                    </span>
                                </div>
                            </el-row>
                            <el-row class="level-item">
                                <div style="width: 100%; display: flex; justify-content: space-between;">
                                    <span>
                                        结算:
                                    </span>
                                    <span>
                                        {{ pp.zzPriceOfSettlement }}
                                    </span>
                                </div>
                            </el-row>
                            <el-row class="level-item">
                                <div style="width: 100%; display: flex; justify-content: space-between;">
                                    <span>
                                        {{ pp.updateTime }}
                                    </span>
                                </div>
                            </el-row>
                        </el-col>
                    </el-row>
                </el-col>
            </el-row> -->
        </el-dialog>
    </div>
</template>

<script>
    import { extractImageUrls, nowpatch, parseDoubleVerticalImageUrls, parseQualityDesc, patformimaglogo } from "@/utils/utils";
    import axios from "axios";
    import qs from "qs";
    import Swal from "sweetalert2";

    export default {
        name: "ultrataskView",
        props: {
            prop: Object,
        },
        data() {
            return {
                // 查询待审核手机
                selecttaslPhoneURL: this.prop.selecttaslPhoneURL,
                // 菜单栏下拉框
                formdataMenuSelectURL: this.prop.formdataMenuSelectURL,

                // 个人出价情况
                selectnowchecknumURL: "/api/taskInfo/getTaskAuditNumber",
                // 出价结果检查
                extraBuyURL: "/api/orderDetails/currentOrderList",
                // 获取全部转转价格
                zzpriceURL: "/api/systemEvaluatePrice/queryByPage",
                // 查询外部账户
                ecxaccountURL: "/api/externalAccount/queryOrderExternalAccount",
                // 审核出价
                nobuyURL: "/api/taskInfo/checkPriceAddOrder",

                // 查询今日任务
                selecttsakURL: "/api/taskInfo/getTaskInfoInit",

                // 获取等级
                gradeURL: "/api/level/getLevelByPlatform",

                //  任务情况
                nowchecknumDict: {
                    numberOfTotal: 0,
                    numberOfUnAudited: 0,
                    numberOfAudited: 0,
                    numberOfSuccessTotal: 0,
                },

                // 任务列表
                taskrunList: [],
                // 待审核手机
                taskphoneList: [],
                wwe: [],

                someFormObject: "",
                // 每行行高
                rowHeight: [],
                // 重置筛选的类型列表
                TyperesetsearchtaskSet: new Set(["s", "b", "m", "g", "clearmenu", "initall", "initall2"]),

                indeterminate: false,

                // 是否有序排列
                orderbyfromhightolowflag: true,

                // 前端过滤的数据
                filtertaskphoneList: [],
                originaltaskphoneList: [],

                checkStatusmenu: [
                    { label: "全部", value: -1 },
                    { label: "未审核", value: 0 },
                    { label: "已审核", value: 1 },
                ],
                // 下拉框初始化
                formdataMenu: {
                    brandList: [],
                    gradeList: [],
                    modelList: [],
                    screenList: [],
                    shuckList: [],
                    sourcesList: [],
                },

                windowScroll: null,
                lasspasscheckrowstyleIndex: null,
                isPriceHighorLow: [
                    { text: "起拍高出95新结算50元以下", value: "high" },
                    { text: "起拍高出95新结算50元以上", value: "low" },
                    { text: "95新结算价高于起拍价", value: "antihigh" },
                ],

                PriceHighorLowPopShow: false,
                PriceHighorLowSelect: [],

                tempgoods: null,
                isButtonDisabled: false,
                timerId: null,

                informationList: [],
                allzzpriceDialogShow: false,
                freshtime: 10,
                CalculatedataList: [],

                // 定时器
                timer: null,

                // 进度条颜色
                colors: [
                    { color: "#f56c6c", percentage: 20 },
                    { color: "#e6a23c", percentage: 40 },
                    { color: "#1989fa", percentage: 60 },
                    { color: "#6f7ad3", percentage: 90 },
                    { color: "#5cb87a", percentage: 100 },
                ],
                //进度条
                percentage: 0,
                processshow: false,

                ecxaccountList: [],

                passcheck: [],

                // 前端计算的价格列表
                frontCalList: [],
                total: 1,

                // 筛选菜单栏
                menuselect: {
                    patch: nowpatch(),
                    taskId: null,
                    pageNo: 1,
                    pageSize: 10,
                    sourcesList: "",
                    brandList: "",
                    modelList: "",
                    gradeList: "",
                    checkStatus: "",
                    screenList: "",
                    shuckList: "",
                    orderByUpsetPrice: 0,
                },

                taskrunid: "",

                wwe: this.prop,
                amount: "",
                amountOld: "",
                selectedItem: null,
                options: [1, 2, 3, 4, 5],
                isFocused: false,
                inputColor: "red", // 默认颜色
                styleObject: {
                    color: "red",
                    fontSize: "26px",
                },
            };
        },
        methods: {
            // 根据 quotedQuantity 生成下拉框选项
            getOptions(row) {
                const options = [];
                for (let i = 1; i <= row.quotedQuantity; i++) {
                    options.push(i);
                }
                return options;
            },
            getRowStyle({ row, column, rowIndex, columnIndex }) {
                if (row.todayDataFlag === false && columnIndex == 3) {
                    return {
                        "background-color": "#F56C6C",
                        "pointer-events": "none",
                    };
                } else {
                    return { "pointer-events": "none" };
                }
            },
            // 找出 95 结算价格
            getQuality95Price(priceList) {
                if (!Array.isArray(priceList)) return null;
                const _item = priceList.find((item) => item.quality == "95");
                return _item ? this.tempcval(_item.zzLowestSalePrice) : null;
            },

            // 出价结果显示
            getPlatFormRes(row, index, goodid, sources, autoGeneratePrice, operationType) {
                axios
                    .get(this.extraBuyURL, {
                        headers: {
                            satoken: localStorage.sa,
                        },
                        params: {
                            patch: row.patch,
                            stickCode: row.stickCode,
                        },
                    })
                    .then((response) => {
                        let res = response.data.data.result[0];
                        if (res.orderResult !== "success" && typeof res.orderResult !== "undefined") {
                            if (sources == "回收宝") {
                                Swal.fire({
                                    title: "发生了一些错误..",
                                    html: `
                                            <div style="text-align: left;">
                                            ${res.sources}平台提示:${res.orderResult || "未知错误"}
                                                </div>
                                                <div>当前出价:${row.amount}<div>
                                                `,
                                    icon: "error",
                                    showCancelButton: true,
                                    cancelButtonColor: "red",
                                    cancelButtonText: "强制出价",
                                    confirmButtonColor: "#3085d6",
                                    confirmButtonText: "不出价",
                                }).then((result) => {
                                    if (result.isConfirmed) {
                                    } else if (result.dismiss === Swal.DismissReason.cancel) {
                                        this.nobuy(index, goodid, sources, autoGeneratePrice, operationType, row, 1);
                                    }
                                });
                            } else {
                                Swal.fire({
                                    title: "发生了一些错误..",
                                    html: `
                                            <div style="text-align: left;">
                                            ${res.sources}平台提示:${res.orderResult || "未知错误"}
                                                </div>
                                                `,
                                    icon: "error",
                                    showCancelButton: false,
                                    cancelButtonColor: "red",
                                    cancelButtonText: "强制出价",
                                    confirmButtonColor: "#3085d6",
                                    confirmButtonText: "好的",
                                });
                            }

                            this.searchTask("buyerror");
                            return false;
                        } else {
                            // 外部账号出价成功
                            this.$message.success("操作成功!");
                            this.lasspasscheckrowstyleIndex = row.id;
                            this.windowScroll = event.pageY;
                            this.passcheck = [];
                            this.searchTask("buysuccess");
                        }
                    })
                    .catch((error) => { });
            },
            // 出价审核
            checkpass(gid, accountId, operationType, row, isforce) {
                axios
                    .post(
                        this.nobuyURL,
                        {
                            id: gid,
                            accountId: accountId,
                            amount: row.amount,
                            operationType: operationType,
                            taskId: this.menuselect.taskId,
                            quotedQuantity: row.quotedQuantity == 1 ? row.quotedQuantity : row.orderQuotedQuantity,
                            force: isforce || undefined,
                        },
                        {
                            headers: {
                                satoken: localStorage.sa,
                            },
                            // params: isforce ? { force: isforce } : {},
                        }
                    )
                    .then((res) => {
                        this.searchTask("checkpass");
                    });
            },

            editPrice(currentValue, oldValue) {
                currentValue !== null ? (this.amount = String(currentValue)) : (this.amount = String(oldValue));
            },

            handleFocus(event, idx) {
                const inputEle = this.$refs["tab" + idx].$el.querySelector(".el-input__inner");
                if (inputEle) {
                    inputEle.select();
                }
                if (event.target.classList.contains("el-input__inner")) {
                    event.target.style.color = "red";
                    event.target.style.fontSize = "large";
                } else {
                    event.target.style.color = "#F56C6C";
                    event.target.style.fontSize = "large";
                }
                // this.amount = ''
            },
            handleblur(row) { },

            // 取账户
            nobuy(index, goodid, sources, autoGeneratePrice, operationType, row, isforce) {
                /**
                 *  index:                  当前行索引          -- 用于查看当前行的审核价格
                 *  goodid:                 当前商品的id        -- 用于指定商品峡下单
                 *  sources:                当前商品的来源      -- 用于查询账户
                 *  autoGeneratePrice:      当前商品的计算价格  -- 应该是后端传来的价格
                 *  operationType:          当前操作的类型      -- 用户点击的按钮
                 * */
                if (this.prop.usewarepriceid) {
                    goodid = row.warePriceId;
                }
                let amount;
                // 非跳过时 type = 0||1
                if (operationType != 2) {
                    if (row.amount != 0 || this.passcheck[index] != null) {
                        // 有上次出价价格
                        operationType = 1;
                        amount = this.passcheck[index];
                    } else {
                        // 首次出价
                        operationType = 0;
                        if (autoGeneratePrice == -1) {
                            amount = 0;
                            autoGeneratePrice = this.frontCalList[index];
                        } else {
                        }
                    }
                }
                // 无论通过,跳过,都需要获取账户
                axios
                    .get(this.ecxaccountURL, {
                        headers: {
                            satoken: localStorage.sa,
                        },
                        params: {
                            sources: sources,
                        },
                        paramsSerializer: (params) => {
                            return qs.stringify(params, { indices: false });
                        },
                    })
                    .then((res) => {
                        let orderAccount = res.data.data[0];
                        if (operationType === 2 || orderAccount.accountStatus === 0) {
                            if (operationType == 2) {
                                // 如果是跳过操作类型为 2，直接调用 checkpass
                                this.checkpass(goodid, orderAccount.id, operationType, row, isforce);
                            } else {
                                // 点击通过
                                if (operationType == 1 || operationType == 0) {
                                    const info_dict = {
                                        0: "⚫ 您的出价大于了 4,000 !",
                                        1: "⚫ 您的出价为转转结算价!",
                                        2: "⚫ 您的出价高于起拍价的两倍!",
                                    };
                                    const messages = [];
                                    if (row.amount > 3999) {
                                        messages.push(info_dict[0]);
                                    }

                                    const amountExists = row.systemEvaluatePriceList.some((item) => item.zzPriceOfSettlement == row.amount);

                                    if (amountExists) {
                                        messages.push(info_dict[1]);
                                    }

                                    if (row.amount >= 2 * row.upsetPrice) {
                                        messages.push(info_dict[2]);
                                    }

                                    if (messages.length > 0) {
                                        Swal.fire({
                                            title: "出价提示",
                                            html: messages.join("<br>"),
                                            icon: "info",
                                            showCancelButton: true,
                                            confirmButtonText: "确认出价",
                                            cancelButtonText: "取消",
                                        }).then((result) => {
                                            if (result.isConfirmed) {
                                                this.checkpass(goodid, orderAccount.id, operationType, row, isforce);
                                            } else {
                                                this.$message.info("您取消了出价..");
                                            }
                                        });
                                    } else {
                                        this.checkpass(goodid, orderAccount.id, operationType, row, isforce);
                                    }
                                }
                            }
                        } else {
                            // 否则提示错误，账号不可用
                            this.$message.error("外部账号不可用,请检查您对应平台的账号密码!");
                            return;
                        }
                    });
            },

            handleDialogClose() {
                // 在这里添加关闭对话框的逻辑
                // 比如隐藏对话框等
                // this.isButtonDisabled = false
            },

            // 循环图片
            showallimages(s, b) {
                if (s == "" || s == {} || s == undefined) {
                    return this.extractImageUrls(b);
                } else if (s != undefined) {
                    return s.split("|").concat(this.extractImageUrls(b));
                }
            },

            // 展示图片
            loopfirstimage(s, b) {
                if (s == "" || s == {} || s == undefined) {
                    return this.extractImageUrls(b)[0];
                } else {
                    return s.split("|")[0];
                }
            },

            // 多库存手机解析循环
            onemorephonepicsCircle(s, b) {
                if (s == "" || s == {} || s == undefined) {
                    return this.extractImageUrls(b);
                } else {
                    let ppt = parseDoubleVerticalImageUrls(s);

                    return ppt.flat().concat(this.extractImageUrls(b));
                }
            },

            // 查询当前任务审核状态
            selectnowchecknum() {
                axios
                    .get(this.selectnowchecknumURL, {
                        headers: {
                            satoken: localStorage.sa,
                        },
                        params: {
                            taskId: this.menuselect.taskId,
                            patch: this.menuselect.patch,
                            sourcesList: this.menuselect.sourcesList,
                        },
                        paramsSerializer: (params) => {
                            return qs.stringify(params, { indices: false });
                        },
                    })
                    .then((res) => {
                        if (res.data.success) {
                            this.nowchecknumDict = res.data.data;
                        }
                    });
            },

            // 查询当前审核的手机
            searchTask(type) {
                if (type == "initall") {
                    this.getruntaskList();
                }
                this.passcheck = [];

                // 先选任务模块
                if (this.menuselect.taskId) {
                } else {
                    this.$message.error("您还未选择任务名称!");
                    this.taskphoneList = [];
                    return;
                }
                if (type == "initall2") {
                    this.getformdataMenuData(type);
                }
                this.selectnowchecknum();
                axios
                    .get(this.selecttaslPhoneURL, {
                        headers: {
                            satoken: localStorage.sa,
                        },
                        params: {
                            // patch: this.menuselect.patch,
                            // taskId: this.menuselect.taskId,
                            // pageNo: this.menuselect.pageNo,
                            // pageSize: this.menuselect.pageSize,
                            ...this.menuselect,
                        },
                        paramsSerializer: (params) => {
                            return qs.stringify(params, { indices: false });
                        },
                    })
                    .then((res) => {
                        if (res.data.success) {
                            const updatedData = res.data.data.result.map((item) => ({
                                ...item, // 保留原来的字段
                                isButtonDisabled: false,
                                lastClickedTime: null,
                            }));
                            this.taskphoneList = updatedData;
                            this.total = res.data.data.total;
                        }
                        window.scrollTo({
                            top: this.lasspasscheckrowstyleIndex - window.innerHeight / 2, // 滚动到点击位置上方
                            behavior: "smooth", // 平滑滚动
                        });
                        // this.resetgetRowHeights();
                    });
            },

            // 清空行高
            resetgetRowHeights() {
                this.rowHeight = new Array(this.menuselect.pageSize).fill(0);
                setTimeout(() => {
                    this.getRowHeights();
                }, 0.05 * 1000);
            },

            // 获取每行行高
            getRowHeights() {
                // 获取 el-table 的 DOM 实例
                if (this.$refs.eltableRef) {
                    const tableRef = this.$refs.eltableRef.$el;
                    // 获取所有行的元素
                    const rows = tableRef.querySelectorAll(".el-table__row");
                    // 获取每一行的高度,新的数据时更新
                    this.rowHeight = Array.from(rows).map((item) => item.clientHeight - 10);
                }
            },

            // 查询任务名称
            getruntaskList() {
                axios
                    .get(this.selecttsakURL, {
                        headers: {
                            satoken: localStorage.sa,
                        },
                        params: {
                            patch: this.menuselect.patch,
                        },
                    })
                    .then((res) => {
                        if (res.data.success) {
                            this.taskrunList = res.data.data;
                            if (this.taskrunList.length == 0) {
                                Swal.fire({
                                    title: `未查询到任务!`,
                                    html: `当前批次【${this.menuselect.patch}】还未给您派发任务, 您可以联系管理员派发任务, 或刷新页面试试!`,
                                    icon: "warning",
                                    confirmButtonText: "好的",
                                    allowOutsideClick: false,
                                    // showCancelButton: true,
                                    // cancelButtonText: "留在本页",
                                }).then((res) => {
                                    if (res.isConfirmed) {
                                        // this.$router.push('/treasure');
                                    }
                                });
                            }
                            this.menuselect.taskId = "";
                        } else {
                            this.$message.error(res.data.data);
                        }
                    })
                    .catch((error) => {
                        this.data = error;
                        console.error("获取数据出错:", error);
                    });
            },

            //获取等级
            getGradeList() {
                axios
                    .get(this.gradeURL, {
                        headers: {
                            satoken: localStorage.sa,
                        },
                        params: {
                            platform: this.menuselect.sourcesList,
                        },
                    })
                    .then((res) => {
                        if (res.data.success) {
                            this.formdataMenu.gradeList = res.data.data;
                        } else {
                            this.$message.error("获取筛选条件失败!");
                        }
                    });
            },

            // 选完任务后 => 筛选栏数据请求
            // 手机条件下拉框初始化
            getformdataMenuData(type, sources) {
                if (type == "s" && sources) {
                    this.getGradeList();
                }

                if (type == "initall2" || type == "s" || type == "b" || type == "m") {
                    // 重选品牌
                    if (type == "initall2" || type == "s" || type == "b" || type == "m" || type == "g") {
                        // this.menuselect.gradeList = "";
                        //  重选型号
                        if (type == "initall2" || type == "s" || type == "b") {
                            this.menuselect.modelList = "";
                            // 重选等级
                            if (type == "initall2" || type == "s") {
                                this.menuselect.brandList = "";
                                // 重选平台
                                if (type == "initall2") {
                                    this.menuselect.sourcesList = "";
                                }
                            }
                        }
                    }
                }
                if (this.TyperesetsearchtaskSet.has(type)) {
                    axios
                        .get(this.formdataMenuSelectURL, {
                            headers: {
                                satoken: localStorage.sa,
                            },
                            params: {
                                patch: this.menuselect.patch,
                                taskId: this.menuselect.taskId,
                                sourcesList: this.menuselect.sourcesList,
                                brandList: this.menuselect.brandList,
                                modelList: this.menuselect.modelList,
                                screenList: this.menuselect.screenList,
                                shuckList: this.menuselect.shuckList,

                                // gradeList: this.menuselect.gradeList,
                            },
                            paramsSerializer: (params) => {
                                return qs.stringify(params, { indices: false });
                            },
                        })
                        .then((res) => {
                            if (res.data.success) {
                                this.formdataMenu.screenList = res.data.data.screenList;
                                this.formdataMenu.shuckList = res.data.data.shuckList;

                                // 重选等级
                                if (type != "g") {
                                    // this.formdataMenu.gradeList = res.data.data.gradeList;
                                    //  重选型号
                                    if (type != "m") {
                                        this.formdataMenu.modelList = res.data.data.modelList;
                                        // 重选品牌
                                        if (type != "b") {
                                            this.formdataMenu.brandList = res.data.data.brandList;
                                            // 重选平台
                                            if (type != "s") {
                                                this.formdataMenu.sourcesList = res.data.data.sourcesList;
                                            }
                                        }
                                    }
                                }
                                this.searchTask("menu");
                            } else {
                                this.$message.error("获取筛选条件失败!");
                            }
                        });
                }
            },

            // 重置所有选择
            resetSelection() {
                const lists = ["sourcesList", "brandList", "modelList", "gradeList", "checkStatus", "screenList", "shuckList"];
                lists.forEach((list) => {
                    this.menuselect[list] = "";
                });
                this.getformdataMenuData("clearall");
                this.searchTask("clearmenu");
            },

            // 解析图片路径
            extractImageUrls(anu) {
                return extractImageUrls(anu);
            },

            // 前端公式
            tempcval(oriprice) {
                if (oriprice == null) {
                    return;
                }
                let tempfixprce = 75;
                if (oriprice < 1100) {
                    tempfixprce = 60;
                }
                // let _tempfrontcolprice = Math.ceil((oriprice * 0.94 - tempfixprce) / 1.1) todo
                let _tempfrontcolprice = Math.ceil(oriprice * 0.94 - tempfixprce);

                return _tempfrontcolprice;
            },
            // 计算前端价格
            dofrontCalList(index, oriprice) {
                let _tempfrontcolprice = this.tempcval(oriprice);
                this.frontCalList[index] = _tempfrontcolprice;
                return String(_tempfrontcolprice);
            },

            // 上次出价
            lastpasschexk(passStatus, Calindex, lastprice) {
                let temppasscheck = [];
                /**
                 * 需求: 回显上次成功出价的数据;
                 */
                if (lastprice != 0) {
                    temppasscheck[Calindex] = lastprice;
                }
                // 更新出价列表
                this.passcheck = temppasscheck;
                return temppasscheck;
            },
            // 筛选方法
            filterprice(value, row) {
                const _priceList = row.systemEvaluatePriceList;
                const _upsetPrice = row.upsetPrice;
                // 获取质量为 95 的 结算价格
                const _price = this.getQuality95Price(_priceList);

                if (_price === null) return false;

                // 使用一个映射对象来简化条件判断
                const _conditionMap = {
                    antihigh: _price > _upsetPrice,
                    high: _price + 50 >= _upsetPrice,
                    low: _price + 50 < _upsetPrice,
                };
                // 如果 value 不在映射中，返回 false
                return _conditionMap[value] ?? false;
            },
            _parseQualityDesc(svae) {
                return parseQualityDesc(svae);
            },
            // 显示平台logo
            _patformimaglogo(_platformname) {
                return patformimaglogo(_platformname);
            },
            // 改变条数
            handleSizeChange(val) {
                this.menuselect.pageSize = val;
                this.searchTask("size");
                this.prop.fatherscroll();
            },
            //改变页数
            handleCurrentChange(val) {
                this.menuselect.pageNo = val;
                this.searchTask("page");
                this.prop.fatherscroll();
            },
            //自动高度设置
            autobuttonheight(index) {
                return {
                    height: `50px`,
                    //height: `${this.rowHeight[index]}px`,
                };
            },
            // 上次点击行
            lastcheckstyle({ row, rowIndex }) {
                if (row.id == this.lasspasscheckrowstyleIndex) {
                    return {
                        background: "#fdc4c4d0!important",
                    };
                }
                if (rowIndex % 2 == 0) {
                    return {
                        background: "rgba(14, 95, 255, 0.00)",
                    };
                } else {
                    return {
                        background: "rgba(14, 95, 255, 0.05)",
                    };
                }
            },
            // 单元格点击
            handleCellClick(row, column, cell, event) {
                // 阻止事件冒泡，防止重复触发
                event.stopPropagation();

                // 获取行列Index并存在一个数组中
                this.activeCellIndex = [row.index, column.index];
                // 使其获取焦点
                this.$nextTick(() => {
                    const ref = this.$refs["tab" + row.index];
                    if (ref) {
                        ref.focus();
                    }
                    const priceref = this.$refs["tab" + row.index + column.index];
                });
            },
            // 把每列的索引放进column中
            tableCellClassName({ column, columnIndex }) {
                column.index = columnIndex;
            },
            // 把每行的索引放进row中
            tableRowClassName({ row, rowIndex }) {
                row.index = rowIndex;
            },
            // 处理表头点击事件
            handleHeaderClick(column, event) {
                if (column.label === "1") {
                    this.PriceHighorLowPopShow = !this.PriceHighorLowPopShow;
                }
            },
            // 合并表头
            headFirst({ row, column, rowIndex, columnIndex }) {
                let base = {
                    "background-color": "rgb(107, 107, 107)",
                    "text-align": "center",
                };

                if (row[columnIndex].label === "操作") {
                    this.$nextTick(() => {
                        document.querySelector(`.${column.id}`).setAttribute("colspan", "2");
                    });
                }
                if (row[columnIndex].property === "hi") {
                    return { ...base, display: "none" };
                }
                return base;
            },
            // 点击行事件
            handleRowClick(row, column, event) {
                this.lasspasscheckrowstyleIndex = row.id;
                this.windowScroll = event.pageY;
                // 仅在点击行时获取行高
            },
            /* ################################## */
            /*               获取转转估价               */
            /* ################################## */
            fetchPriceData(row, freshtype, callback) {
                let id = row.id;
                if (this.prop.usewarepriceid) {
                    id = row.warePriceId;
                }
                if (freshtype === 0) {
                    freshtype = {};
                } else {
                    freshtype = {
                        requestType: "refresh",
                    };
                }

                this.tempgoods = row;
                this.informationList = [];

                axios
                    .get(this.zzpriceURL, {
                        headers: {
                            satoken: localStorage.sa,
                        },
                        params: {
                            id: id,
                            ...freshtype,
                        },
                    })
                    .then((res) => {
                        if (res.data.success) {
                            this.informationList = res.data.data;
                            this.wwe = this.formatzzprice(this.informationList);
                            if (callback) callback();
                        } else {
                            this.$message.error(res.data.message);
                            this.getallzzprice(row, 0);
                        }
                    })
                    .catch((error) => {
                        this.$message.error("获取数据出错:", error);
                    });
            },
            getallzzprice(row, freshtype) {
                this.selectedItem = row;
                const currentTime = new Date().getTime();
                if (row.lastClickedTime && currentTime - row.lastClickedTime < 30000) {
                    row.isButtonDisabled = true;
                } else {
                    row.isButtonDisabled = false;
                }

                this.fetchPriceData(row, freshtype, () => {
                    this.allzzpriceDialogShow = true; // 成功后打开对话框
                });
            },
            getallzzpriceAgain(row, freshtype) {
                const currentTime = new Date().getTime();
                row.lastClickedTime = currentTime;
                row.isButtonDisabled = true; // 禁用按钮 30 秒

                this.fetchPriceData(row, freshtype);

                setTimeout(() => {
                    row.isButtonDisabled = false; // 30 秒后重新启用按钮
                }, 30000);
            },
            getallzzpriceRefresh(row, freshtype) {
                this.fetchPriceData(row, freshtype); // 只获取数据，没有其他附加操作
            },
            formatzzprice(resList) {
                let tempList = [];
                resList.forEach((leveldict) => {
                    leveldict.systemEvaluatePriceVOList.forEach((priceitem) => {
                        priceitem.quality = leveldict.condition + priceitem.quality;
                        if (priceitem.title !== "") {
                            tempList.push(priceitem);
                        }
                    });
                });
                return tempList;
            },
            /* ################################## */
            /*              转转估价弹窗显示              */
            /* ################################## */
            rangeZZRows() {
                return Math.ceil((this.informationList || []).length / 2); // 每行2项，计算总行数
            },
            getZZRowData(rowIndex) {
                const start = rowIndex * 2;
                const end = start + 2;
                return this.informationList.slice(start, end); // 获取每行的两个项
            },
        },
        watch: {
            orderbyfromhightolowflag(newVal, oldVal) {
                this.menuselect.orderByUpsetPrice = this.orderbyfromhightolowflag ? 0 : -1;
            },
        },
        computed: {
            // 表格样式
            tableRowStyle() {
                return (row) => ({
                    background: row.rowIndex % 2 === 0 ? "rgba(14, 95, 255, 0.4)" : "rgba(14, 95, 255, 0.4)",
                    color: "black",
                });
            },
        },
        created() { },
        mounted() {
            this.getruntaskList();
        },
    };
</script>

<style lang="scss" scoped>
    .level-row {
        display: flex;
        justify-content: space-between;
        margin-bottom: 10px;
        /* 控制行间距 */
    }

    .level-item {
        text-align: center;
        border: 1px solid #ccc;
        /* 给每个项加一个边框 */
        padding: 10px;
        /* 给每个项加一些内边距 */
        border-radius: 5px;
        /* 圆角边框 */
        background-color: #f9f9f9;
        /* 背景色 */
    }

    .el-col-7 {
        max-width: 14.28571429%;
        flex: 0 0 14.28571429%;
    }

    .el-table {
        justify-content: center;
        --el-table-text-color: #000000;
        --el-table-border: 1px solid #ebeef5;
        --el-table-header-bg-color: #6b6b6b;
        --el-table-header-text-color: white;
    }

    .btn {
        height: 36px;
        width: 80px;
        border-radius: 6px;
        background-color: #007bff;
        border-color: #2e6da4;
        color: #ffffff;
        margin-right: 10px;
    }

    .btn:hover {
        background-color: #0056b3;
        border-color: #204d74;
    }

    .my-input-class {
        --input-color: red;
        /* 默认颜色 */
        font-size: large;
    }

    .my-input-class.focused {
        /* 当聚焦且有focused类时 */
        --input-color: red;
        /* 聚焦时的颜色 */
    }
</style>
